import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  DONE_REFRESHING_TOKEN,
  RESTORE_SUCCESS,
} from "../actions/types";

const user = JSON.parse(localStorage.getItem("userData"));

const initialState = user
  ? { isLoggedIn: true, user }
  : { isLoggedIn: false, user: null };

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case REGISTER_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        data:payload.user
      };
    case REGISTER_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        errors:payload.errors,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        user: payload.user,
      };
    case LOGIN_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
      case DONE_REFRESHING_TOKEN:
      return {
        ...state,
        isLoggedIn: true,
      };
    // case REFRESH_FAIL:
    //   return {
    //     ...state,
    //     isLoggedIn: false,
    //     user: null,
    //   };
    case LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    default:
      return state;
  }
}
